(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6921],{

/***/ 87575:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/network/blogs",
      function () {
        return __webpack_require__(48173);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 48173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Network; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65988);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(45046);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(50491);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(12450);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(49458);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(56365);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(37051);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(93692);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(44740);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(25504);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5152);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52500);
/* harmony import */ var _styles_Business_module_css__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(90260);
/* harmony import */ var _styles_Business_module_css__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_styles_Business_module_css__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _components_Layouts_homeLayout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93674);
/* harmony import */ var _components_Notification__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96691);
/* harmony import */ var react_alert__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19412);
/* harmony import */ var _contexts_Auth__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(92842);
/* harmony import */ var _components_Gthr_Scheduler_Utils_Calendar__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64881);
/* harmony import */ var _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6644);
/* harmony import */ var _components_Meta__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(18549);




















function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Demo = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_6__["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6911), __webpack_require__.e(6106), __webpack_require__.e(1683), __webpack_require__.e(6517)]).then(__webpack_require__.bind(__webpack_require__, 66517));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66517)
            ];
        }
    },
    ssr: false
});
var navigation = (/* unused pure expression or super */ null && ([]));
var tiers = [
    {
        name: 'Hobby',
        href: '#',
        priceMonthly: 0,
        description: 'All the basics for starting a new business',
        includedFeatures: [
            'Customizable video templates',
            'Create up to five rooms a month',
            '1-on-1 meetings'
        ]
    },
    {
        name: 'Freelancer',
        href: '#',
        priceMonthly: 12,
        description: 'All the basics for starting a new business',
        includedFeatures: [
            'Create a booking page',
            'Set available hours or create events',
            '1-on-1 and group meetings',
            'Live support for new features', 
        ]
    },
    {
        name: 'Startup',
        href: '#',
        priceMonthly: 24,
        description: 'All the basics for starting a new business',
        includedFeatures: [
            'Includes all freelancer tools',
            'Up to 5,000 minutes',
            'Custom CRM and Calendly Integrations',
            'Priority live support for new features', 
        ]
    },
    {
        name: 'Pay-per-meeting',
        href: '#',
        priceMonthly: "--",
        description: 'Do you need more booked meetings for your business?',
        includedFeatures: [
            "We'll get you booked meetings for a fixed price",
            'Great for agencies',
            'Only pay for real face-to-face meetings', 
        ]
    }, 
];
var features = [
    {
        name: 'Accept Payments',
        description: 'Add a payment gateway to book meetings',
        icon: _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z
    },
    {
        name: 'Create a Booking Page',
        description: 'Use a landing page for clients to book meetings and receive inquiries',
        icon: _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z
    },
    {
        name: 'Schedule recurring or one-time events',
        description: 'Setup recurring or one-time events',
        icon: _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z
    },
    {
        name: 'CRM Integrations',
        description: "Let us know what type of integration you need and we'll help you out",
        icon: _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z
    },
    {
        name: 'Post to Notion',
        description: 'Automatically create a page in notion with your meeting notes for future reference',
        icon: _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z
    },
    {
        name: 'Custom Template',
        description: "Do you have a mockup or idea for a new template? Let's build it!",
        icon: _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z
    },
    {
        name: 'Calculator Editor',
        description: 'Use a collaborative calculator to provide custom quotes or show how much clients could save with your product/service',
        icon: _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z
    },
    {
        name: 'Add Triggers',
        description: 'Setup custom triggers to automatically send a user a follow-up email, giftcard, or plant a tree  ',
        icon: _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z
    }, 
];
function Network() {
    var tz = Intl.DateTimeFormat().resolvedOptions().timeZone ? Intl.DateTimeFormat().resolvedOptions().timeZone : "America/Los_Angeles";
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(true), /*#__PURE__*/ stopCode = ref6[0], setStopCode = ref6[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0), subPage = ref1[0], setSubPage = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), submitted = ref2[0], setSubmitted = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        "name": "",
        "person": "",
        "email": "",
        "notes": "",
        "dateStr": null,
        "student_profile": null,
        "appointment_datetime": null,
        "timezone": tz,
        "meeting_dates": []
    }), meeting = ref4[0], setMeeting = ref4[1];
    var ref5 = (0,_contexts_Auth__WEBPACK_IMPORTED_MODULE_11__/* .useAuth */ .a)(), user = ref5.user, signOut = ref5.signOut;
    var handleChange = function(e) {
        var newMeeting = _objectSpread({}, meeting);
        if (e.target) {
            newMeeting[e.target.name] = e.target.value;
            setMeeting(newMeeting);
        }
    };
    var handleTimeChange = function(newValue) {
        var newMeeting = _objectSpread({}, meeting);
        newMeeting.timezone = newValue.value;
        setMeeting(newMeeting);
    };
    var handleDateStr = function(dateTime) {
        var newMeeting = _objectSpread({}, meeting);
        newMeeting["dateStr"] = dateTime.toFormat('DD');
        newMeeting["appointment_datetime"] = dateTime.toISO();
        setMeeting(newMeeting);
    };
    var requestAccount = function() {
        var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(e) {
            var ref, data, error;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        e.preventDefault();
                        _ctx.next = 4;
                        return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_13__/* .supabase.from */ .O.from("main_request_access").insert({
                            email: meeting.email,
                            type: "network"
                        });
                    case 4:
                        ref = _ctx.sent;
                        data = ref.data;
                        error = ref.error;
                        error && console.log(error);
                        !error && setSubmitted(true);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        //might want to send email
        }));
        return function requestAccount(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "jsx-174f2eebf65a3d90" + " " + "relative overflow-hidden",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Meta__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                title: "Plaza Advertising Network",
                description: "The Plaza advertising network connects virtual coaches and consultants to thrid-party publishers to help coaches receive new leads and clients"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("main", {
                className: "jsx-174f2eebf65a3d90",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
                        className: "jsx-174f2eebf65a3d90" + " " + "pt-10 bg-slate-200/50 -mt-0 sm:pt-10 lg:pt-0 lg:pb-14 lg:overflow-hidden mb-2 sm:mb-40 md:mb-40 lg:mb-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "jsx-174f2eebf65a3d90" + " " + "mx-auto max-w-7xl lg:px-8",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "jsx-174f2eebf65a3d90" + " " + "lg:grid lg:grid-cols-2 lg:gap-8",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "jsx-174f2eebf65a3d90" + " " + "mx-auto h-full max-w-md px-4 sm:max-w-2xl sm:px-6 sm:text-center lg:px-0 lg:text-left lg:flex lg:items-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "jsx-174f2eebf65a3d90" + " " + "lg:py-24",
                                            children: [
                                                "     ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "jsx-174f2eebf65a3d90" + " " + 'mt-1',
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                        className: "jsx-174f2eebf65a3d90" + " " + 'text-fuchsia-700 bg-fuchsia-100 px-2 py-1 rounded-lg',
                                                        children: "Coming Soon"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h1", {
                                                    className: "jsx-174f2eebf65a3d90" + " " + "mt-4 text-5xl tracking-tight font-extrabold mb-10 text-black sm:mt-5 sm:text-6xl lg:mt-2 xl:text-5xl",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                                            className: "jsx-174f2eebf65a3d90" + " " + "block ",
                                                            children: [
                                                                "The ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                    className: "jsx-174f2eebf65a3d90" + " " + "text-fuchsia-600",
                                                                    children: "first"
                                                                }),
                                                                " advertising"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                                            className: "jsx-174f2eebf65a3d90" + " " + "block ",
                                                            children: [
                                                                " network for ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                    className: "jsx-174f2eebf65a3d90" + " " + "underline decoration-fuchsia-600 decoration-wavy decoration-4",
                                                                    children: "virtual coaches"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "jsx-174f2eebf65a3d90" + " " + "blur-3xl  -ml-10  absolute h-32 w-32 -z-10 bg-fuchsia-500"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                    className: "jsx-174f2eebf65a3d90" + " " + "mt-3 text-base text-gray-700 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl",
                                                    children: "As a virtual coach/consultant, let us get you fresh leads to sustain your business with our network of third-party publishers"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "jsx-174f2eebf65a3d90" + " " + "mt-10 sm:mt-12",
                                                    children: !submitted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                                                        action: "#",
                                                        className: "jsx-174f2eebf65a3d90" + " " + "sm:max-w-xl sm:mx-auto lg:mx-0",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                                className: "jsx-174f2eebf65a3d90" + " " + "sm:flex",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                                        className: "jsx-174f2eebf65a3d90" + " " + "min-w-0 flex-1",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                                                                htmlFor: "email",
                                                                                className: "jsx-174f2eebf65a3d90" + " " + "sr-only",
                                                                                children: "Email address"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                                                name: "email",
                                                                                defaultValue: meeting.email,
                                                                                onChange: handleChange,
                                                                                placeholder: "Enter your email",
                                                                                className: "jsx-174f2eebf65a3d90" + " " + "block w-full px-4 py-3 rounded-md border-0 text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-300 focus:ring-offset-gray-900"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                        className: "jsx-174f2eebf65a3d90" + " " + "mt-3 sm:mt-0 sm:ml-3",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                                                            onClick: requestAccount,
                                                                            className: "jsx-174f2eebf65a3d90" + " " + "block w-full py-3 px-4 rounded-md hover:text-gray-900 shadow-lg shadow-fuchsia-500/50 bg-fuchsia-700 text-white font-medium hover:bg-fuchsia-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 focus:ring-offset-gray-900",
                                                                            children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                                className: "jsx-174f2eebf65a3d90" + " " + "flex justify-center",
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                    fill: "none",
                                                                                    viewBox: "0 0 24 24",
                                                                                    className: "jsx-174f2eebf65a3d90" + " " + "animate-spin h-5 w-5 my-auto text-zinc-900 ",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
                                                                                            cx: "12",
                                                                                            cy: "12",
                                                                                            r: "10",
                                                                                            stroke: "currentColor",
                                                                                            strokeWidth: "4",
                                                                                            className: "jsx-174f2eebf65a3d90" + " " + "opacity-25"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                                                                            fill: "currentColor",
                                                                                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z",
                                                                                            className: "jsx-174f2eebf65a3d90" + " " + "opacity-75"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }) : "Request Account"
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                                className: "jsx-174f2eebf65a3d90" + " " + "mt-3 text-sm text-gray-600 sm:mt-4",
                                                                children: [
                                                                    " By providing your email, you agree to our",
                                                                    ' ',
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_5__["default"], {
                                                                        href: "/terms-conditions",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                                            className: "jsx-174f2eebf65a3d90" + " " + "font-medium text-gray-900",
                                                                            children: "terms of service"
                                                                        })
                                                                    }),
                                                                    "."
                                                                ]
                                                            })
                                                        ]
                                                    }) : submitted && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        className: "jsx-174f2eebf65a3d90" + " " + "flex items-center justify-center lg:justify-start lg:mx-0",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                                                className: "text-green-600 h-7 w-7 mr-3"
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                className: "jsx-174f2eebf65a3d90",
                                                                children: "Email submitted.  We'll follow-up within 24 hours."
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "jsx-174f2eebf65a3d90" + " " + " lg:pt-20 -mb-16 sm:-mb-48 lg:m-0 lg:relative",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "jsx-174f2eebf65a3d90" + " " + "blur-3xl mt-20 -ml-10 right-0 absolute h-32 w-32 -z-10 bg-fuchsia-500"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "jsx-174f2eebf65a3d90" + " " + 'my-auto',
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "jsx-174f2eebf65a3d90" + " " + 'bg-white border-2 p-5 rounded-lg w-full ',
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                                            className: "jsx-174f2eebf65a3d90" + " " + 'font-extrabold text-xl text-slate-700  ',
                                                            children: "Available Nutritionists"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                            className: "jsx-174f2eebf65a3d90" + " " + 'space-x-6 flex mt-3',
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                                    className: "jsx-174f2eebf65a3d90" + " " + 'w-1/3',
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                                                            className: "rounded-full",
                                                                            width: "500",
                                                                            height: "250",
                                                                            src: "https://d28zq0um2frnpx.cloudfront.net/static/women2_waive.jpg",
                                                                            objectFit: "cover",
                                                                            alt: "plaza icon"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                                                            className: "jsx-174f2eebf65a3d90" + " " + 'font-extrabold text-slate-800 ',
                                                                            children: "Jessica Peters"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                            className: "jsx-174f2eebf65a3d90" + " " + 'text-slate-500 text-sm min-h-[100px]',
                                                                            children: "Tired of the endless diet schedule?  Diets don't work for everyone, I can help setup your own personal plan"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                                                            className: "jsx-174f2eebf65a3d90" + " " + "w-full mt-2  shadow-lg shadow-slate-400/50 py-1 border border-transparent text-base font-medium rounded-md text-white bg-slate-500 hover:bg-slate-900",
                                                                            children: "Book"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                                    className: "jsx-174f2eebf65a3d90" + " " + 'w-1/3',
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                                                            className: "rounded-full",
                                                                            width: "500",
                                                                            height: "250",
                                                                            src: "https://d28zq0um2frnpx.cloudfront.net/static/woman_1_home.jpg",
                                                                            objectFit: "cover",
                                                                            alt: "plaza icon"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                                                            className: "jsx-174f2eebf65a3d90" + " " + 'font-extrabold text-slate-800 ',
                                                                            children: "Sarah Thomas"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                            className: "jsx-174f2eebf65a3d90" + " " + 'text-slate-500 text-sm min-h-[100px]',
                                                                            children: "Looking for a sports nutritionists to help you acheive your athletic goals?"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                                                            className: "jsx-174f2eebf65a3d90" + " " + "w-full  mt-2  shadow-lg shadow-slate-400/50 py-1 border border-transparent text-base font-medium rounded-md text-white bg-slate-500 hover:bg-slate-900",
                                                                            children: "Book"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                                    className: "jsx-174f2eebf65a3d90" + " " + 'w-1/3',
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                                                            className: "rounded-full",
                                                                            width: "500",
                                                                            height: "250",
                                                                            src: "https://d28zq0um2frnpx.cloudfront.net/static/man1-waive.jpg",
                                                                            objectFit: "cover",
                                                                            alt: "plaza icon"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                                                            className: "jsx-174f2eebf65a3d90" + " " + 'font-extrabold text-slate-800 ',
                                                                            children: "John Lawrence"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                            className: "jsx-174f2eebf65a3d90" + " " + 'text-slate-500 text-sm min-h-[100px]',
                                                                            children: "If you're seeking freedom from your eating disorder, I help breakdown the importantance of restoring your balanace"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                                                            className: "jsx-174f2eebf65a3d90" + " " + "w-full shadow-lg mt-2 shadow-slate-400/50 py-1 border border-transparent text-base font-medium rounded-md text-white bg-slate-500 hover:bg-slate-900",
                                                                            children: "Book"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                            className: "jsx-174f2eebf65a3d90" + " " + 'mt-5 flex items-center justify-end space-x-4',
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                    className: "jsx-174f2eebf65a3d90" + " " + 'text-slate-500 mr-2 text-sm',
                                                                    children: "Powered by"
                                                                }),
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                                                    width: "20",
                                                                    height: "20",
                                                                    src: "https://d28zq0um2frnpx.cloudfront.net/static/plaza-tail-transparent.png",
                                                                    objectFit: "cover",
                                                                    alt: "plaza icon"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
                        className: "jsx-174f2eebf65a3d90" + " " + "relative bg-white pt-16 pb-32 overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "jsx-174f2eebf65a3d90" + " " + "",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "jsx-174f2eebf65a3d90" + " " + "lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "jsx-174f2eebf65a3d90" + " " + "px-4 max-w-xl mx-auto sm:px-6 lg:py-32 lg:max-w-none lg:mx-0 lg:px-0 lg:col-start-2",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                className: "jsx-174f2eebf65a3d90",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "jsx-174f2eebf65a3d90" + " " + 'z-20 relative',
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                            className: "jsx-174f2eebf65a3d90" + " " + "h-12 w-12 rounded-md flex items-center justify-center bg-fuchsia-700",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                                className: "h-6 w-6 text-white",
                                                                "aria-hidden": "true"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        className: "jsx-174f2eebf65a3d90" + " " + "mt-6 z-20 relative",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                                                className: "jsx-174f2eebf65a3d90" + " " + "text-3xl font-extrabold tracking-tight text-gray-900",
                                                                children: "For virtual coaches/consultants"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                                className: "jsx-174f2eebf65a3d90" + " " + "mt-4 text-lg text-gray-500",
                                                                children: "Are you looking for more customers at an affordable acquisition cost?  Book a demo to discuss how we can help you generate more clients.  Options include leads delivered to your inbox or booked discovery calls"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                className: "jsx-174f2eebf65a3d90" + " " + "mt-6",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                                    href: "#bookDemo",
                                                                    className: "jsx-174f2eebf65a3d90" + " " + "inline-flex px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-fuchsia-700 hover:bg-fuchsia-900",
                                                                    children: "Book a Demo"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "jsx-174f2eebf65a3d90" + " " + "mt-12 sm:mt-16 lg:mt-0 lg:col-start-1 flex items-center  ",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "jsx-174f2eebf65a3d90" + " " + "pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 my-auto img-cont z-10",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                                    className: (_styles_Business_module_css__WEBPACK_IMPORTED_MODULE_24___default().editorMockup) + " scale-125",
                                                    src: "".concat(_config__WEBPACK_IMPORTED_MODULE_7__/* .cloudfront */ .bG, "/static/coach_directory_mock.png"),
                                                    width: 1920,
                                                    height: 1180,
                                                    objectFit: "cover",
                                                    alt: "Plaza for video consultations"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "jsx-174f2eebf65a3d90" + " " + "relative mt-24",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "jsx-174f2eebf65a3d90" + " " + "lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "jsx-174f2eebf65a3d90" + " " + "px-4 max-w-xl mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                className: "jsx-174f2eebf65a3d90",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "jsx-174f2eebf65a3d90",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                            className: "jsx-174f2eebf65a3d90" + " " + "h-12 w-12 rounded-md flex items-center justify-center bg-fuchsia-700",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                                                className: "h-6 w-6 text-white",
                                                                "aria-hidden": "true"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        className: "jsx-174f2eebf65a3d90" + " " + "mt-6 mr-10",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                                                className: "jsx-174f2eebf65a3d90" + " " + "text-3xl font-extrabold tracking-tight text-gray-900",
                                                                children: "For Websites, Publishers, and Influencers"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                                className: "jsx-174f2eebf65a3d90" + " " + "mt-4 text-lg text-gray-500 relative z-20",
                                                                children: [
                                                                    "Try a brand new way of monetizing your site!  Copy + paste your unique Plaza script into your website and start generating revenue for each lead or meeting you generate.  Plaza's unqiue embeddable script allows visitors to book a discovery call or submit their information",
                                                                    ' ',
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                        className: "jsx-174f2eebf65a3d90" + " " + "underline decoration-fuchsia-600 decoration-dotted decoration-4",
                                                                        children: "without leaving your site "
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                className: "jsx-174f2eebf65a3d90" + " " + "mt-6",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                                    href: "#",
                                                                    className: "jsx-174f2eebf65a3d90" + " " + "inline-flex px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-fuchsia-700 hover:bg-indigo-700",
                                                                    children: "Get started"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "jsx-174f2eebf65a3d90" + " " + "mt-12 sm:mt-16 lg:mt-0 flex items-center ",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "jsx-174f2eebf65a3d90" + " " + "pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 img-cont",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                                    className: "scale-150",
                                                    src: "".concat(_config__WEBPACK_IMPORTED_MODULE_7__/* .cloudfront */ .bG, "/static/directory_code_mock.png"),
                                                    width: 2020,
                                                    height: 1080,
                                                    objectFit: "cover",
                                                    alt: "Plaza for video consultations"
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "jsx-174f2eebf65a3d90" + " " + "py-16 bg-slate-200/50 overflow-hidden lg:py-24",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "jsx-174f2eebf65a3d90" + " " + "relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                                        width: 404,
                                        height: 784,
                                        fill: "none",
                                        viewBox: "0 0 404 784",
                                        "aria-hidden": "true",
                                        className: "jsx-174f2eebf65a3d90" + " " + "hidden lg:block absolute left-full transform -translate-x-1/2 -translate-y-1/4",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
                                                className: "jsx-174f2eebf65a3d90",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("pattern", {
                                                    id: "b1e6e422-73f8-40a6-b5d9-c8586e37e0e7",
                                                    x: 0,
                                                    y: 0,
                                                    width: 20,
                                                    height: 20,
                                                    patternUnits: "userSpaceOnUse",
                                                    className: "jsx-174f2eebf65a3d90",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("rect", {
                                                        x: 0,
                                                        y: 0,
                                                        width: 4,
                                                        height: 4,
                                                        fill: "currentColor",
                                                        className: "jsx-174f2eebf65a3d90" + " " + "text-gray-200"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("rect", {
                                                width: 404,
                                                height: 784,
                                                fill: "url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)",
                                                className: "jsx-174f2eebf65a3d90"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "jsx-174f2eebf65a3d90" + " " + "blur-3xl  ml-10  absolute h-32 w-32 -z-10 bg-fuchsia-400"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        id: "bookDemo",
                                        className: "jsx-174f2eebf65a3d90" + " " + "relative",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                            className: "jsx-174f2eebf65a3d90" + " " + "text-center text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl",
                                            children: "Book a demo"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "jsx-174f2eebf65a3d90" + " " + "blur-3xl right-0 mr-48 absolute h-32 w-48 -z-10 bg-fuchsia-400"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "jsx-174f2eebf65a3d90" + " " + "min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "jsx-174f2eebf65a3d90" + " " + " sm:mx-auto sm:w-full sm:max-w-3xl",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "jsx-174f2eebf65a3d90" + " " + "bg-white   w-full shadow-xl sm:rounded-lg ",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Gthr_Scheduler_Utils_Calendar__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                    meeting: meeting,
                                                    handleChange: handleChange,
                                                    handleDateStr: handleDateStr,
                                                    handleTimeChange: handleTimeChange,
                                                    subPage: subPage,
                                                    setSubPage: setSubPage,
                                                    setMeeting: setMeeting,
                                                    business: true,
                                                    activity: null,
                                                    slug: "ldew2"
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "jsx-174f2eebf65a3d90" + " " + '',
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                        className: "jsx-174f2eebf65a3d90"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                        className: "jsx-174f2eebf65a3d90"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                        className: "jsx-174f2eebf65a3d90"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                        className: "jsx-174f2eebf65a3d90"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                        className: "jsx-174f2eebf65a3d90"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                        className: "jsx-174f2eebf65a3d90"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                        className: "jsx-174f2eebf65a3d90" + " " + "text-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_5__["default"], {
                                                href: "/terms-conditions",
                                                prefetch: false,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                    className: "jsx-174f2eebf65a3d90",
                                                    children: " Terms & Conditions | "
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_5__["default"], {
                                                href: "/cookie-policy",
                                                prefetch: false,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                    className: "jsx-174f2eebf65a3d90",
                                                    children: " Cookie Policy | "
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_5__["default"], {
                                                href: "/privacy-policy",
                                                prefetch: false,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                    className: "jsx-174f2eebf65a3d90",
                                                    children: "Privacy Policy"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        className: "jsx-174f2eebf65a3d90" + " " + "text-center text-gray-400",
                                        children: "\xa9 2022 Ordinary Media, LLC. All Rights Reserved."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_2___default()), {
                id: "174f2eebf65a3d90",
                children: ".img-cont>span{overflow:visible!important}\nbody{overlfow\n         }"
            })
        ]
    }));
};
var alertOptions = {
    // you can also just use 'bottom right'
    position: react_alert__WEBPACK_IMPORTED_MODULE_10__/* .positions.BOTTOM_RIGHT */ .m7.BOTTOM_RIGHT,
    timeout: 3000,
    offset: '10px',
    containerStyle: {
        'zIndex': '9999'
    },
    // you can also just use 'fade'
    transition: react_alert__WEBPACK_IMPORTED_MODULE_10__/* .transitions.FADE */ .pB.FADE
};
Network.getLayout = function getLayout(page) {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_alert__WEBPACK_IMPORTED_MODULE_10__/* .Provider */ .zt, _objectSpread({
        template: _components_Notification__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z
    }, alertOptions, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_contexts_Auth__WEBPACK_IMPORTED_MODULE_11__/* .AuthProvider */ .H, {
            /*#__PURE__*/ children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Layouts_homeLayout__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                children: page
            })
        })
    })));
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9225,5675,3640,3616,5988,7612,6848,3334,5953,9101,2702,471,4881,5554,9774,2888,179], function() { return __webpack_exec__(87575); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);